var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/email.png": "9afb",
	"./assets/logo-color.png": "aa44",
	"./assets/logo-white.png": "d939",
	"./assets/logo.png": "cf05",
	"./assets/mobile/about/comp/huayi-content.png": "22c8",
	"./assets/mobile/about/comp/huayi.jpg": "5845",
	"./assets/mobile/about/comp/hzzw-content.png": "689d",
	"./assets/mobile/about/comp/hzzw.jpg": "ebad",
	"./assets/mobile/about/comp/tongli-content.png": "a7be",
	"./assets/mobile/about/comp/tongli.jpg": "1b77",
	"./assets/mobile/about/comp/ylmf-content.png": "8e38",
	"./assets/mobile/about/comp/ylmf.jpg": "9cdc",
	"./assets/mobile/about/leader/1.jpg": "d7e7",
	"./assets/mobile/about/leader/2.jpg": "c412",
	"./assets/mobile/about/leader/3.jpg": "e2af",
	"./assets/mobile/about/leader/4.jpg": "af73",
	"./assets/mobile/about/leader/5.jpg": "2385",
	"./assets/mobile/about/leader/6.jpg": "05cd",
	"./assets/mobile/about/leader/7.jpg": "46a2",
	"./assets/mobile/about/pos1-bg.jpg": "03ba",
	"./assets/mobile/about/pos2-tit.png": "b4e8",
	"./assets/mobile/about/pos3-bg.jpg": "580f",
	"./assets/mobile/about/pos4-bg.jpg": "03ec",
	"./assets/mobile/about/pos5-tit.png": "5740",
	"./assets/mobile/about/pos6-tit.png": "f3a8",
	"./assets/mobile/contact/map0.jpg": "60ca",
	"./assets/mobile/contact/map1.jpg": "69ef",
	"./assets/mobile/contact/map2.jpg": "63d8",
	"./assets/mobile/contact/map3.jpg": "809b",
	"./assets/mobile/contact/map4.jpg": "b754",
	"./assets/mobile/contact/pos1-bg.jpg": "4eb4",
	"./assets/mobile/home/brand/amaxz.jpg": "7b4b",
	"./assets/mobile/home/brand/hqms.jpg": "b871",
	"./assets/mobile/home/brand/huayi.jpg": "9d74",
	"./assets/mobile/home/brand/hzzw.jpg": "102c",
	"./assets/mobile/home/brand/iforce.jpg": "71cb",
	"./assets/mobile/home/brand/itrax.jpg": "d3bc",
	"./assets/mobile/home/brand/kxyz.jpg": "3503",
	"./assets/mobile/home/brand/ldg.jpg": "630f",
	"./assets/mobile/home/brand/mt.jpg": "f343",
	"./assets/mobile/home/brand/pairui.jpg": "7b26",
	"./assets/mobile/home/brand/qctt.jpg": "33fd",
	"./assets/mobile/home/brand/ss.jpg": "b520",
	"./assets/mobile/home/brand/tongli.jpg": "18bb",
	"./assets/mobile/home/brand/ylmf.jpg": "67a3",
	"./assets/mobile/home/brand/zagh.jpg": "c801",
	"./assets/mobile/home/brand/zwzs.jpg": "2198",
	"./assets/mobile/home/brand/zywl.jpg": "4c34",
	"./assets/mobile/home/case-title.png": "83d6e",
	"./assets/mobile/home/customer-tit.png": "3adf",
	"./assets/mobile/home/jiandang-cover.jpg": "3f08",
	"./assets/mobile/home/pos1-bg.jpg": "0cf6",
	"./assets/mobile/home/pos1-txt.png": "a0aa",
	"./assets/mobile/home/pos2-bg.jpg": "7cee",
	"./assets/mobile/home/pos3-bg.jpg": "4c45",
	"./assets/mobile/home/pos4-bg.jpg": "13d1",
	"./assets/mobile/home/pos5-bg.jpg": "7b68",
	"./assets/mobile/home/pos7-bg.jpg": "7b73",
	"./assets/mobile/home/pos7-icon.png": "9568",
	"./assets/mobile/home/pos8-bg.jpg": "dbfe",
	"./assets/mobile/home/we-bg.jpg": "c180",
	"./assets/mobile/home/we-title.png": "dced",
	"./assets/mobile/invest/pos1-bg.jpg": "386e",
	"./assets/mobile/jiandang/bg.jpg": "154b8",
	"./assets/mobile/job/pos1-bg.jpg": "3f02",
	"./assets/mobile/logo.png": "99bf",
	"./assets/mobile/news/pos1-bg.jpg": "1510",
	"./assets/mobile/service/pos1-bg.jpg": "6f7d",
	"./assets/mobile/service/pos2-bg.jpg": "3444",
	"./assets/mobile/service/pos3-bg.jpg": "99ed",
	"./assets/mobile/service/pos4-bg.jpg": "ccd4",
	"./assets/mobile/service/pos5-bg.jpg": "9b34",
	"./assets/pc/about/brand/amaxz.jpg": "29c5",
	"./assets/pc/about/brand/bg1.jpg": "9347",
	"./assets/pc/about/brand/bg2.jpg": "2fdb",
	"./assets/pc/about/brand/bg3.jpg": "0b00",
	"./assets/pc/about/brand/bg4.jpg": "4abc",
	"./assets/pc/about/brand/content-huayi.png": "7007",
	"./assets/pc/about/brand/content-hzzw.png": "8877",
	"./assets/pc/about/brand/content-tongli.png": "9252",
	"./assets/pc/about/brand/content-ylmf.png": "0fea",
	"./assets/pc/about/brand/hqms.jpg": "7ceb",
	"./assets/pc/about/brand/huayi.jpg": "1ed1",
	"./assets/pc/about/brand/hzzw.jpg": "7640",
	"./assets/pc/about/brand/iforce.jpg": "aea4",
	"./assets/pc/about/brand/itrax.jpg": "0f64",
	"./assets/pc/about/brand/kxyz.jpg": "d15c",
	"./assets/pc/about/brand/ldg.jpg": "03f7",
	"./assets/pc/about/brand/mtszys.jpg": "e5b4",
	"./assets/pc/about/brand/pairui.jpg": "08c3",
	"./assets/pc/about/brand/qctt.jpg": "bbbe",
	"./assets/pc/about/brand/ss.jpg": "f305",
	"./assets/pc/about/brand/tongli.jpg": "0818",
	"./assets/pc/about/brand/ylmf.jpg": "6704",
	"./assets/pc/about/brand/zagh.jpg": "f3f7",
	"./assets/pc/about/brand/zwzs.jpg": "d2a0",
	"./assets/pc/about/brand/zywl.jpg": "f9e3",
	"./assets/pc/about/p1_bg.jpg": "142c",
	"./assets/pc/about/p3_bg.jpg": "ae2f",
	"./assets/pc/about/p4_bg.jpg": "6e74",
	"./assets/pc/about/p6_bg.jpg": "c8ab",
	"./assets/pc/about/pos2_banner1.png": "ffee",
	"./assets/pc/about/pos2_banner2.png": "2f7f",
	"./assets/pc/about/pos4_banner.png": "6d8c",
	"./assets/pc/about/pos5_banner.png": "4f07",
	"./assets/pc/about/pos6_banner1.png": "01ef",
	"./assets/pc/about/pos6_banner2.jpg": "fbe3",
	"./assets/pc/contact/icon0.png": "5577",
	"./assets/pc/contact/icon1.png": "5e93",
	"./assets/pc/contact/icon2.png": "018e",
	"./assets/pc/contact/icon3.png": "8b65",
	"./assets/pc/contact/icon4.png": "9169",
	"./assets/pc/contact/map0.jpg": "1070",
	"./assets/pc/contact/map1.jpg": "b346",
	"./assets/pc/contact/map2.jpg": "d102",
	"./assets/pc/contact/map3.jpg": "ba9d",
	"./assets/pc/contact/map4.jpg": "5713",
	"./assets/pc/contact/p1_bg.jpg": "3776",
	"./assets/pc/home/about.png": "303e",
	"./assets/pc/home/brand/amaxz.png": "95f2",
	"./assets/pc/home/brand/hqms.png": "7d83",
	"./assets/pc/home/brand/huayi.png": "fc29",
	"./assets/pc/home/brand/hzzw.png": "c64c",
	"./assets/pc/home/brand/iforce.png": "381c",
	"./assets/pc/home/brand/itrax.png": "faa9",
	"./assets/pc/home/brand/kxyz.png": "418e",
	"./assets/pc/home/brand/lgd.png": "bdbb",
	"./assets/pc/home/brand/mt.png": "675c",
	"./assets/pc/home/brand/pairui.png": "048c",
	"./assets/pc/home/brand/qctt.png": "9c65",
	"./assets/pc/home/brand/ss.png": "af6c",
	"./assets/pc/home/brand/tongli.png": "50e0",
	"./assets/pc/home/brand/xlmf.png": "ccb7",
	"./assets/pc/home/brand/zagh.png": "fcca",
	"./assets/pc/home/brand/zwzs.png": "52dc",
	"./assets/pc/home/brand/zywl.png": "d238",
	"./assets/pc/home/btn-1.png": "9356",
	"./assets/pc/home/btn-2.png": "1c0e",
	"./assets/pc/home/btn-3.png": "2e44",
	"./assets/pc/home/btn-4.png": "6721",
	"./assets/pc/home/btn-7.png": "a54b",
	"./assets/pc/home/hand1.png": "9975",
	"./assets/pc/home/hand2.png": "088a",
	"./assets/pc/home/hand3.png": "e9b9",
	"./assets/pc/home/light.png": "fe74",
	"./assets/pc/home/more-blue.png": "f69a",
	"./assets/pc/home/more-blue2.png": "08d3",
	"./assets/pc/home/more-white.png": "ffd5",
	"./assets/pc/home/more-yellow.png": "c7df",
	"./assets/pc/home/nav/1.a.png": "e364",
	"./assets/pc/home/nav/1.png": "4ad9",
	"./assets/pc/home/nav/2.a.png": "1846",
	"./assets/pc/home/nav/2.png": "7330",
	"./assets/pc/home/nav/3.a.png": "148d",
	"./assets/pc/home/nav/3.png": "4222",
	"./assets/pc/home/nav/4.a.png": "6250",
	"./assets/pc/home/nav/4.png": "99ad",
	"./assets/pc/home/next.png": "7948",
	"./assets/pc/home/p1_bg.jpg": "e224",
	"./assets/pc/home/p2_bg.jpg": "e2a2",
	"./assets/pc/home/p2_bg_2.jpg": "7385",
	"./assets/pc/home/p4_bg.jpg": "9c79",
	"./assets/pc/home/p6_bg.jpg": "5a78",
	"./assets/pc/home/p7_bg.jpg": "7535",
	"./assets/pc/home/pos1/ball1.png": "2c65",
	"./assets/pc/home/pos1/ball2.png": "2bf0",
	"./assets/pc/home/pos1/huan.png": "2326",
	"./assets/pc/home/pos1/txt.png": "9e19",
	"./assets/pc/home/pos2_banner.png": "b640",
	"./assets/pc/home/pos2_txt.png": "353b",
	"./assets/pc/home/pos3_banner.jpg": "14eb",
	"./assets/pc/home/pos3_txt.png": "5323",
	"./assets/pc/home/pos4_banner.png": "a3dd",
	"./assets/pc/home/pos4_txt.png": "3dd7",
	"./assets/pc/home/pos5_banner.png": "7e9c",
	"./assets/pc/home/pos5_s1.png": "7a30",
	"./assets/pc/home/pos5_s2.png": "3cf4",
	"./assets/pc/home/pos5_s3.png": "974e",
	"./assets/pc/home/pos5_txt.png": "cd36",
	"./assets/pc/home/pos6_txt.png": "789b",
	"./assets/pc/home/pos7_banner.jpg": "c1a4",
	"./assets/pc/home/pos7_banner1.png": "0af6",
	"./assets/pc/home/pos7_banner2.png": "4712",
	"./assets/pc/home/pos7_txt.png": "ffca",
	"./assets/pc/home/video-btn-dark.png": "865b",
	"./assets/pc/home/video-btn.png": "9a7f",
	"./assets/pc/invest/p1_bg.jpg": "165a",
	"./assets/pc/jiandang/bg.jpg": "3d1e",
	"./assets/pc/jiandang/more.png": "fd56",
	"./assets/pc/job/p1_bg.jpg": "374e",
	"./assets/pc/mp.png": "e715",
	"./assets/pc/news/b.png": "b06a",
	"./assets/pc/news/p1_bg.jpg": "6bf9",
	"./assets/pc/news/pos1_banner.png": "6d40",
	"./assets/pc/service/content/p1_bg.jpg": "bdee",
	"./assets/pc/service/content/pos2_banner.png": "023b",
	"./assets/pc/service/digital_culture/p1_bg.jpg": "a1cb",
	"./assets/pc/service/digital_culture/pos2_banner.png": "c02b",
	"./assets/pc/service/innovation/p1_bg.jpg": "5e5c",
	"./assets/pc/service/innovation/pos2_banner.png": "4546",
	"./assets/pc/service/marketing/p1_bg.jpg": "2e38",
	"./assets/pc/service/marketing/pos2_banner.png": "ee8d",
	"./assets/pc/service/spread/p1_bg.jpg": "e97e",
	"./assets/pc/service/spread/pos2_banner.png": "4d2c",
	"./assets/qr.jpg": "6585",
	"./assets/weibo.png": "794d",
	"./assets/weixin.png": "6ed4",
	"./column.config": "f6bd",
	"./column.config.js": "f6bd",
	"./components/KLine": "b4d3",
	"./components/KLine.vue": "b4d3",
	"./components/List": "2e90",
	"./components/List.vue": "2e90",
	"./components/VideoDetail": "f300",
	"./components/VideoDetail.vue": "f300",
	"./components/mobile/InvestRow": "17e9",
	"./components/mobile/InvestRow.vue": "17e9",
	"./components/mobile/MoreBtn": "fe73",
	"./components/mobile/MoreBtn.vue": "fe73",
	"./components/mobile/Row": "23ba",
	"./components/mobile/Row.vue": "23ba",
	"./components/mobile/footer": "3857",
	"./components/mobile/footer.vue": "3857",
	"./components/mobile/header": "9894",
	"./components/mobile/header.vue": "9894",
	"./components/mobile/nav": "61d3",
	"./components/mobile/nav.vue": "61d3",
	"./components/pc/HomeText": "5cda",
	"./components/pc/HomeText.vue": "5cda",
	"./components/pc/HomeVideo": "76e8",
	"./components/pc/HomeVideo.vue": "76e8",
	"./components/pc/InvestRow": "b5bc",
	"./components/pc/InvestRow.vue": "b5bc",
	"./components/pc/Pager": "11f8",
	"./components/pc/Pager.vue": "11f8",
	"./components/pc/Row": "e299",
	"./components/pc/Row.vue": "e299",
	"./components/pc/Video": "c38e",
	"./components/pc/Video.vue": "c38e",
	"./components/pc/footer": "397a",
	"./components/pc/footer.vue": "397a",
	"./components/pc/nav": "4d90",
	"./components/pc/nav.vue": "4d90",
	"./content.css": "274a",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./settings": "83d6",
	"./settings.js": "83d6",
	"./views/mobile/About": "44d2",
	"./views/mobile/About.vue": "44d2",
	"./views/mobile/About/HuaYi": "714a",
	"./views/mobile/About/HuaYi.vue": "714a",
	"./views/mobile/About/Hzzw": "567e",
	"./views/mobile/About/Hzzw.vue": "567e",
	"./views/mobile/About/TongLi": "935a",
	"./views/mobile/About/TongLi.vue": "935a",
	"./views/mobile/About/Ylmf": "d545",
	"./views/mobile/About/Ylmf.vue": "d545",
	"./views/mobile/Contact": "eada",
	"./views/mobile/Contact.vue": "eada",
	"./views/mobile/Home": "52ea",
	"./views/mobile/Home.vue": "52ea",
	"./views/mobile/Invest": "29a3",
	"./views/mobile/Invest.vue": "29a3",
	"./views/mobile/InvestList": "5a2e",
	"./views/mobile/InvestList.vue": "5a2e",
	"./views/mobile/Jiandang": "ec31",
	"./views/mobile/Jiandang.vue": "ec31",
	"./views/mobile/JiandangDetail": "5b54",
	"./views/mobile/JiandangDetail.vue": "5b54",
	"./views/mobile/Job": "642d",
	"./views/mobile/Job.vue": "642d",
	"./views/mobile/JobNone": "2264",
	"./views/mobile/JobNone.vue": "2264",
	"./views/mobile/Notice": "b260",
	"./views/mobile/Notice.vue": "b260",
	"./views/mobile/news": "900b",
	"./views/mobile/news.vue": "900b",
	"./views/mobile/newsDetail": "b647",
	"./views/mobile/newsDetail.vue": "b647",
	"./views/mobile/service": "f817",
	"./views/mobile/service.vue": "f817",
	"./views/pc/About": "252b",
	"./views/pc/About.vue": "252b",
	"./views/pc/About/HuaYi": "78d6",
	"./views/pc/About/HuaYi.vue": "78d6",
	"./views/pc/About/Hzzw": "e733",
	"./views/pc/About/Hzzw.vue": "e733",
	"./views/pc/About/TongLi": "72a0",
	"./views/pc/About/TongLi.vue": "72a0",
	"./views/pc/About/Ylmf": "49b7",
	"./views/pc/About/Ylmf.vue": "49b7",
	"./views/pc/Contact": "6525",
	"./views/pc/Contact.vue": "6525",
	"./views/pc/Home": "3cd8",
	"./views/pc/Home.vue": "3cd8",
	"./views/pc/Invest": "b30e",
	"./views/pc/Invest.vue": "b30e",
	"./views/pc/InvestList": "bddf",
	"./views/pc/InvestList.vue": "bddf",
	"./views/pc/Jiandang": "66d7",
	"./views/pc/Jiandang.vue": "66d7",
	"./views/pc/JiandangDetail": "6444",
	"./views/pc/JiandangDetail.vue": "6444",
	"./views/pc/Job": "44a6",
	"./views/pc/Job.vue": "44a6",
	"./views/pc/JobNone": "0d3b",
	"./views/pc/JobNone.vue": "0d3b",
	"./views/pc/NewsTop": "cae5",
	"./views/pc/NewsTop.vue": "cae5",
	"./views/pc/Notice": "9e6d",
	"./views/pc/Notice.vue": "9e6d",
	"./views/pc/Service/Content": "b43f",
	"./views/pc/Service/Content.vue": "b43f",
	"./views/pc/Service/DigitalCulture": "f301",
	"./views/pc/Service/DigitalCulture.vue": "f301",
	"./views/pc/Service/Innovation": "683f",
	"./views/pc/Service/Innovation.vue": "683f",
	"./views/pc/Service/Marketing": "7f9b",
	"./views/pc/Service/Marketing.vue": "7f9b",
	"./views/pc/Service/Spread": "0e8c",
	"./views/pc/Service/Spread.vue": "0e8c",
	"./views/pc/news": "0204",
	"./views/pc/news.vue": "0204",
	"./views/pc/newsDetail": "11c6",
	"./views/pc/newsDetail.vue": "11c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";